import Head from 'next/head'
import { plainToInstance } from 'class-transformer'
import { Waypoint } from 'react-waypoint'

import { Container } from '@components/Container'
import { ContainerStoryCard } from '@components/ContainerStoryCard'
import { StoryCard } from '@components/StoryCard'
import { NewestType } from '@models/newest/NewestType'
import { useDrawer } from '@hooks/contexts/DrawerContext/DrawerContext'
import { BookEnum } from '@interfaces/BookEnum'
import { StoryDetailReaderType } from '@models/story/StoryDetailReaderType'
import { NewestPageProps } from './interface'

export function NewestPage({
  data,
  bookType,
  isLoading,
  handleFetchNextPage,
}: NewestPageProps) {
  const storyDrawer = useDrawer({ drawer: 'story' })

  return (
    <Container className='mobile:px-[20px]'>
      <Head>
        <title>
          {bookType === undefined
            ? 'MaReads มารี้ด | ตอนมาใหม่ ไม่ตกเทรนด์ ฟินทุกวันในจักรวาลใหม่ของนักอ่านนักเขียน'
            : BookEnum.NOVEL
            ? 'MaReads มารี้ด | อ่านนิยายรายตอนมาใหม่ ไม่ตกเทรนด์ ฟินทุกวันในจักรวาลใหม่ของนักอ่านนักเขียน'
            : 'MaReads มารี้ด | อ่านการ์ตูนตอนมาใหม่ ไม่ตกเทรนด์ ฟินทุกวันในจักรวาลใหม่ของนักอ่านนักเขียน'}
        </title>
      </Head>
      <ContainerStoryCard
        title={
          bookType === undefined
            ? 'เรื่องใหม่'
            : bookType === BookEnum.NOVEL
            ? 'นิยายเรื่องใหม่'
            : 'การ์ตูนเรื่องใหม่'
        }
        total={Math.min(data?.pages[0]?.total || 0, 200)}
        isLoading={isLoading}
      >
        {data?.pages.map(page =>
          page?.data.map((item: NewestType) => (
            <StoryCard
              key={item.id}
              id={item.id}
              title={item.title}
              isShowBookPromotion={item.hasSalePromotions}
              buyAllChaptersPromotion={item.buyAllChaptersPromotion}
              bookChapterCampaignHeader={item.bookChapterCampaignHeader}
              readFreePromotion={item.readFreePromotion}
              bookBadges={item.bookBadges}
              imageUrl={item.coverResizeImgPath || item.coverImgPath}
              penName={item.penName?.firstPenName}
              slug={item.penName?.user?.profilePageSlug}
              content={item.cover}
              category={item.category?.name}
              tags={item.tags}
              chapter={item.chapterCount}
              view={item.viewCount}
              chat={item.commentCount}
              like={item.likeCount}
              isLiked={item.isLiked}
              isEnded={item.isEnded}
              bookType={item.bookType}
              categoryId={item.category?.id}
              handleClickStoryCard={() => {
                storyDrawer.show({
                  bookId: item.id,
                  initialData: plainToInstance(StoryDetailReaderType, {
                    id: item.id,
                    coverImgPath: item.coverImgPath,
                    title: item.title,
                    writingType: item.writingType,
                    publishedAt: item.publishedAt,
                    cover: item.cover,
                    viewCount: item.viewCount,
                    commentCount: item.commentCount,
                    likeCount: item.likeCount,
                    publishedChapterCount: item.chapterCount,
                    penName: item.penName,
                    category: item.category,
                    bookType: item.bookType,
                    tags: item.tags,
                    rating: item.rating,
                    isEnded: item.isEnded,
                    isEpub: item.isEpub,
                    isPdf: item.isPdf,
                    isLiked: item.isLiked,
                  }),
                })
              }}
            />
          ))
        )}
      </ContainerStoryCard>
      {data &&
        data.pages.length &&
        data.pages[0].data.length !== 0 &&
        !isLoading && <Waypoint onEnter={handleFetchNextPage} />}
    </Container>
  )
}
